// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lock-off"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.5 10H19.5V21H4.5V10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 11L6.99999 7C6.99999 4.23858 9.23857 2 12 2C14.2388 2 16.134 3.47145 16.7711 5.5M4.5 11H19.5V21H4.5V11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 16H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LockOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lock-off',
    ref,
    icon: element,
  },
));

LockOffIcon.displayName = 'LockOffIcon';

export default LockOffIcon;
